const IconFullEpisodesVideo = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.08 3.11993H6.23998C5.44558 3.11993 4.79998 3.76553 4.79998 4.55993V4.79993H4.07998C3.28558 4.79993 2.63998 5.44553 2.63998 6.23993V6.95993H1.91998C1.12558 6.95993 0.47998 7.60553 0.47998 8.39993V19.4399C0.47998 20.2343 1.12558 20.8799 1.91998 20.8799H18.24C19.0344 20.8799 19.68 20.2343 19.68 19.4399V18.7199H20.4C21.1944 18.7199 21.84 18.0743 21.84 17.2799V16.5599H22.08C22.8744 16.5599 23.52 15.9143 23.52 15.1199V4.55993C23.52 3.76553 22.8744 3.11993 22.08 3.11993ZM18.72 19.4399C18.72 19.7039 18.504 19.9199 18.24 19.9199H1.91998C1.65598 19.9199 1.43998 19.7039 1.43998 19.4399V8.39993C1.43998 8.13593 1.65598 7.91993 1.91998 7.91993H2.63998V17.2799C2.63998 18.0743 3.28558 18.7199 4.07998 18.7199H18.72V19.4399ZM20.88 17.2799C20.88 17.5439 20.664 17.7599 20.4 17.7599H4.07998C3.81598 17.7599 3.59998 17.5439 3.59998 17.2799V6.23993C3.59998 5.97593 3.81598 5.75993 4.07998 5.75993H4.79998V15.1199C4.79998 15.9143 5.44558 16.5599 6.23998 16.5599H20.88V17.2799ZM22.56 15.1199C22.56 15.3839 22.344 15.5999 22.08 15.5999H6.23998C5.97598 15.5999 5.75998 15.3839 5.75998 15.1199V4.55993C5.75998 4.29593 5.97598 4.07993 6.23998 4.07993H22.08C22.344 4.07993 22.56 4.29593 22.56 4.55993V15.1199Z"
      fill="white"
    />
    <path
      d="M16.6392 9.52314L12.912 7.66074C12.5928 7.50234 12.2184 7.73274 12.2184 8.09034V11.8175C12.2184 12.1751 12.5928 12.4055 12.912 12.2471L16.6392 10.3847C16.992 10.2071 16.992 9.70314 16.6392 9.52554V9.52314Z"
      fill="white"
      fillOpacity="0.9"
    />
  </svg>
);

export default IconFullEpisodesVideo;
